import React, { Component, Fragment } from 'react';
import Modal from 'react-bootstrap/Modal';
import isEmpty from 'lodash/isEmpty';
import classNames from 'classnames';

import { downloadFile } from '../../../utils';
import { ErrorText } from '../../../components';

const MAX_VALUE = 100000000;

export default class DetailsModal extends Component {
    constructor() {
        super()
        this.state = this.getInitState();
    }

    getInitState = () => ({
        form: {
            file: '',
            gst: '',
            orderValue: '',
        },
        errors: {}
    })

    onInputChange = e => {
        const { target: { name, value, files } } = e
        this.setState(state => ({
            form: {
                ...state.form,
                [name]: name === 'file' ? files[0] : value,
            },
            errors: {
                ...state.errors,
                [name]: '',
            }
        }))
    }

    onClose = () => {
        this.setState(this.getInitState())
        this.props.updateProperty('data', {});
    }

    onSubmit = e => {
        e.preventDefault();
        if (!this.validateForm()) return
        const { form } = this.state;
        this.props.uploadQuotation({ ...form, id: this.props.data.id })
        this.onClose();
    }

    validateForm = () => {
        const { form } = this.state
        const errors = {}

        if (!form.gst) errors.gst = 'GST is required';
        else if (form.gst < 0 || form.gst > MAX_VALUE) errors.gst = 'GST is Invalid';
        if (!form.orderValue) errors.orderValue = 'Order Value is required';
        else if (form.orderValue < 0 || form.orderValue > MAX_VALUE) errors.gst = 'GST is Invalid';
        if (!form.file) errors.file = 'Quotation is required';
        else if ((form.file.size / 1024 / 1024) > 10) errors.file = 'File should be less than 10 MB.';

        this.setState({ errors });

        return isEmpty(errors)
    }

    downloadFile = (data, type) => {
        downloadFile(data.uploadedFile, `${type}_${data.id}${data.uploadedFile.slice(data.uploadedFile.lastIndexOf('.'))}`, () => {
            this.props.updateProperty('error', 'Error while downloading file');
        })
    }


    render() {
        const { data } = this.props;
        const { form, errors } = this.state;

        return (
            <Modal
                show={!isEmpty(data)}
                onHide={this.onClose}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Uploaded Order
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row">
                    <div className="col-md-12 mb-3">
                        <button className="btn btn-primary" onClick={() => this.downloadFile(data, 'uploaded_order')}>
                            Download Order
                        </button>
                    </div>
                    {data.status === 'uploaded' ? (
                        <Fragment>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label className={classNames({'text-danger': errors.gst})}>GST</label>
                                    <input
                                        name="gst"
                                        type="number"
                                        placeholder="GST"
                                        className={classNames('form-control', { 'is-invalid': errors.gst })} 
                                        value={form.gst}
                                        onChange={this.onInputChange}
                                    />
                                    <ErrorText error={errors.gst}/>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label className={classNames({'text-danger': errors.orderValue})}>Order Value</label>
                                    <input
                                        name="orderValue"
                                        type="number"
                                        placeholder="Order Value" 
                                        className={classNames('form-control', { 'is-invalid': errors.orderValue })} 
                                        value={form.orderValue}
                                        onChange={this.onInputChange}
                                    />
                                    <ErrorText error={errors.orderValue}/>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <p className={classNames({'text-danger': errors.file})}>Upload Quotation</p>
                                    <input
                                        ref={ref => { this.fileSelector = ref }}
                                        name="file"
                                        type="file"
                                        className="hidden" 
                                        onChange={this.onInputChange}
                                    />
                                    <button className="btn btn-secondary" onClick={() => this.fileSelector.click()}>
                                        {form.file ? 'Change File' : 'Select Quotation'}
                                    </button>
                                    <ErrorText error={errors.file}/>
                                </div>
                            </div>
                        </Fragment>
                        ) : (
                            <div className="col-md-12">
                                <button className="btn btn-primary" onClick={() => this.downloadFile(data, 'quotation')}>
                                    Download Quotation
                                </button>
                            </div>
                        )}
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-danger" onClick={this.onClose}>Close</button>
                {data.status === 'uploaded' && <button className="btn btn-primary" onClick={this.onSubmit}>Save</button>}
            </Modal.Footer>
        </Modal>
        )
    }
}